<template>
  <div class="tokyo_tm_home">
    <div class="home_content">
      <div class="avatar">
        <div
          class="image avatar_img"
          :style="{ backgroundImage: 'url(' + src1 + ')' }"
        ></div>
      </div>
      <!-- End .avatar -->
      <div class="details">
        <h3 class="name">38 W Wall St</h3>
        <p class="job">
          Lock in your dates for events you can bank on.
        </p>

        <!--<Social />-->
      </div>
      <!-- End .details -->
    </div>
  </div>
</template>

<script>
  //import Social from "./Social";
  export default {
    components: {
      //Social,
    },
    data() {
      return {
        src1: require("../assets/img/BentonHarborStateBank_1913postcard.jpg"),
      };
    },
  };
</script>

<style lang="scss"></style>
